export const logger = {
  success: message => console.log(message),
  warning: message => console.log(message),
  info: message => console.log(message),
  error: message => console.error(message),
}

export { default as Logger } from './Logger'
